<template></template>
<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "UserListener",
  props: {
    collection: String,
    userID: String
  },
  data() {
      return {
          unsubscribe: null
      }
  },
  mounted() {
    var self = this;
    this.unsubscribe = firebase
      .firestore()
      .collection(self.collection)
      .doc(self.userID)
      .onSnapshot(function(doc) {
        // self.userJSON = doc.data();
        self.$emit("user-real-time", doc.data());
      });
  },
  destroyed() {
      this.unsubscribe();
    // destroy connections
  }
};
</script>